import request from '../utils/request'
//获取文件列表
const getFileList = params => {
  params = {
    tenantId: $config.tenantId,
    folderId: $config.folderId || '',
    instanceId: $config.instanceId,
    moduleType:3,
    type: 1,
    fileTypes:[],
    isFolder: 0,
    sortType: 2,
    isShowSys:0,
    start: 0,
    num: 50,
    ...params
  };
  return request.getJson('/'+$config.tenantId+'/seminar/'+$config.seminarId+'/folder/'+params.folderId+'.json',{baseURL: request.JsonUrl}).catch(function(e){
    return request.postJson('/file/getList', params);
  });

};
const downloadWithEmail = (params) => {
  params = {
    articleId: '',
    forEmailTemp: false,
    emailSubject: "",
    instanceId: $config.instanceId,
    openId: '',
    moduleType: 0,
    extra: {
      tenantId: $config.tenantId,
      instanceId: $config.instanceId,
      memberId: 0,
      moduleId: 3,
      source:"WAP"
    },
    ...params
  }
  return request.postJson('/file/downloadWithEmail', params)
}
export {getFileList,downloadWithEmail}